module.exports = __webpack_public_path__ + "qaumi-0fa286350536f6fc5dfb.svg";